import React, { PureComponent } from 'react'
import { View } from 'react-native'
import Carousel, { Pagination } from 'react-native-snap-carousel'
import styled from 'styled-components/native'

import theme from '../../styles/theme'

const Container = styled(View)`
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colours.lightgrey};
`

export default ({ numberOfSlides, renderItem, scrollEnabled = true }) => {
  return class extends PureComponent {
    constructor (props) {
      super(props)
      this.state = {
        slider: null,
        viewportWidth: null
      }
      this.numberOfSlides = numberOfSlides
      this.scrollEnabled = scrollEnabled
      this.slides = []
      const self = this
      // using this proxy instead of setting slider ref on state and doing an unnecessary re-render
      this.sliderProxy = {
        _snapToItem (val) {
          return self.slider._snapToItem(val)
        },
        _getPositionIndex (index) {
          return self.slider._getPositionIndex(index)
        }
      }
    }

    handleLayout = event => {
      const { width } = event.nativeEvent.layout
      if (this.state.viewportWidth === width) return // layout was already called

      this.setState({
        viewportWidth: width
      })
    }

    render () {
      if (this.props.numberOfSlides) {
        if (this.slides.length !== this.props.numberOfSlides) {
          this.slides = new Array(this.props.numberOfSlides).fill(true)
        }
      } else if (!this.slides.length) {
        if (parseInt(numberOfSlides) > 0) {
          this.slides = new Array(numberOfSlides).fill(true)
        } else {
          this.slides = new Array(numberOfSlides(this.props)).fill(true)
        }
      }
      return (
        <Container onLayout={this.handleLayout}>
          {this.state.viewportWidth && (
            <Carousel
              ref={(c) => { if (!this.slider) { this.slider = c } }}
              enableSnap
              scrollEnabled={this.scrollEnabled}
              firstItem={this.props.currentPage}
              data={this.slides}
              renderItem={({ index }) => renderItem(this.props, index)}
              sliderWidth={this.state.viewportWidth}
              itemWidth={this.state.viewportWidth}
              slideStyle={{ flex: 1, width: this.state.viewportWidth }}
              inactiveSlideOpacity={1}
              inactiveSlideScale={1}
              onSnapToItem={(index) => this.props.updatePage(index)}
              enableMomentum={false}
              decelerationRate='fast'
              snapOnAndroid
              containerCustomStyle={{ flex: 1 }}
            />
          )}
          {this.state.viewportWidth && (
            <Pagination
              key='Pagination'
              dotsLength={this.slides.length}
              activeDotIndex={this.props.currentPage}
              containerStyle={{
                height: theme.paginationHeight,
                paddingHorizontal: 0,
                paddingVertical: 0
              }}
              dotContainerStyle={{
                paddingHorizontal: 7,
                paddingVertical: 10
              }}
              dotStyle={{
                width: 20,
                height: 20,
                borderRadius: 10
              }}
              dotColor={theme.colours.blue}
              inactiveDotColor={theme.colours.blue}
              inactiveDotOpacity={0.4}
              inactiveDotScale={1}
              carouselRef={this.sliderProxy}
              tappableDots
            />
          )}
        </Container>
      )
    }
  }
}
